import CloseIcon from "@material-ui/icons/Close";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { styled } from "@material-ui/core";

export const CloseIconStyled = styled(CloseIcon)({
  fontSize: "20px",
  flexShrink: 0,
  color: "#4F5B94",
});

export const BackIconStyled = styled(ArrowBackIcon)({
  fontSize: "22px",
  flexShrink: 0,
  color: "#4F5B94",
});
